import './style.scss';

export default function MainSection({ children }) {
  return <section className="main">{children}</section>;
}
